module.exports = __webpack_public_path__ + "static/img/xiaochengxu.24e72db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiaochengxu.png
// module id = iief
// module chunks = 2